export default "__VITE_ASSET__CmvZqtMX__"